import React, { FC, memo } from 'react';

import { Divider } from 'antd';

import SharingBlock, { NotifyRecipients } from '../../../Common/SharingBlock';
import CustomMessage from '../../../Common/SharingBlock/CustomMessage';
import { SharedItemType } from '../../../Common/RecipientRoleSelect';
import styles from './ShareHalf.module.scss';
import appConfig from '../../../../config/env';

const {
    ENABLE_SHARE_MESSAGE,
} = appConfig;

interface ShareHalfProps {
    requiresPhoneVerification: boolean;
    requiresPasswordVerification?: boolean;
    requiresPasswordProtection?: boolean;
    hasRecipients: boolean;
    sharedItemType: SharedItemType;
}

const ShareHalf: FC<ShareHalfProps> = ({
    requiresPhoneVerification,
    requiresPasswordVerification = false,
    requiresPasswordProtection = false,
    hasRecipients,
    sharedItemType,
}) => (
    <div className={styles['sharing-policy-block']}>
        <div className={styles['block-wrapper']}>
            <SharingBlock
                showPhones={requiresPhoneVerification}
                showPasswords={requiresPasswordVerification || requiresPasswordProtection}
                sharedItemType={sharedItemType}
            />
        </div>
        {hasRecipients && (
            <>
                <Divider />
                <div className={styles['block-wrapper']}>
                    <NotifyRecipients />
                    {ENABLE_SHARE_MESSAGE && <Divider />}
                    {ENABLE_SHARE_MESSAGE && <CustomMessage />}
                </div>
            </>
        )}
    </div>
);

export default memo(ShareHalf);
